<template>
  <main class="container mx-auto mt-16">
    <UtilsDetailTitleLoading v-if="isLoading" />
    <ArticleDetailTitle
      v-else
      :detail-data="contentsData.attributes"
      text-to="Case Study"
      url="/work"
      :is-case-study="true"
    />

    <!-- <ClientOnly> -->
    <UtilsDetailContentLoading v-if="isLoading" />
    <ArticleDetailContent
      v-else
      :is-case-study="true"
      :detail-data="contentsData.attributes"
    />
    <!-- </ClientOnly> -->

    <WorkCaseStudiesList
      header-text="How We Transform Ideas into Reality"
      :card-count="3"
      :detail-id="contentsData.id"
      :filter-industry="
        contentsData?.attributes?.study_case_client?.data?.attributes?.industry
          ?.data?.attributes?.title
      "
      :filter-expertises="contentsData?.attributes?.expertices?.data"
    />
    <WorkArticlesList
      header-text="We Bring the Featured Insights for You"
      :filter-expertises="contentsData?.attributes?.expertices?.data"
      :filter-industry="
        contentsData?.attributes?.study_case_client?.data?.attributes?.industry
          ?.data?.attributes?.title
      "
    />
  </main>
</template>

<script setup>
import { useGlobalStore } from '~/store/global'

const global = useGlobalStore()
const mainSeo = global.mainSeo ?? {}
const mainBanner = global.mainBanner ?? {}

const route = useRoute()

const isLoading = ref(true)
const contentsData = ref({})

const getContents = async () => {
  const { data, error, pending } = await useSuitmediaApiData(
    `/api/contents/${route.params.slug}`,
    {
      query: {
        populate:
          'image,layout_component,layout_component.type,study_case_client.image,expertices.expertice_category,study_case_client.industry,study_case_client.client_types,seo.image,article_industries',
        'filters[$and][0][layout][$eq]': 'study-case'
      },
      retry: 3,
      retryDelay: 300
    }
  )

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Case Studies does not exist`
    })
  }

  return data.value
}

const contents = await getContents()
contentsData.value = contents.data

const currentLink = computed(() => {
  return window?.location?.href || ''
})

useJsonld({
  '@context': 'https://schema.org/',
  '@type': 'Article',
  name: contentsData?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  url: currentLink.value,
  description:
    contentsData?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  image:
    contentsData?.value?.attributes?.seo?.image.data?.attributes?.url ||
    contentsData?.value?.attributes?.image?.data?.attributes?.url ||
    mainSeo?.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner?.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png',
  datePublished: contentsData.value?.attributes?.publish_at,
  author: contentsData.value?.attributes?.layout_component?.[0]?.author,
  publisher: {
    '@type': 'LocalBusiness',
    name: 'Suitmedia',
    logo: {
      '@type': 'ImageObject',
      url: '/assets/img/site-logo.png'
    }
  },
  headline: contentsData.value?.attributes?.title
})
useSeoMeta({
  title: contentsData?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  ogTitle: contentsData?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  description:
    contentsData?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  ogDescription:
    contentsData?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  ogImage:
    contentsData?.value?.attributes?.seo?.image.data?.attributes?.url ||
    contentsData?.value?.attributes?.image?.data?.attributes?.url ||
    mainSeo?.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner?.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png',
  ogType: contentsData?.value?.attributes?.seo?.open_graph_type,
  twitterTitle: contentsData?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  twitterDescription:
    contentsData?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  twitterImage:
    contentsData?.value?.attributes?.seo?.image.data?.attributes?.url ||
    contentsData?.value?.attributes?.image?.data?.attributes?.url ||
    mainSeo?.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner?.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png'
})
</script>

<style lang="scss" scoped></style>
